import moment from "moment";
import { normalizeBadgeTone } from "../badgeStyles";

const VERSION_REASON_LABELS = {
  scheduled_review: "Scheduled Review",
  incident_based: "Incident Based",
  observation_based: "Observation Based",
  care_plan_inaccurate: "Care Plan No Longer Accurate",
  external_input: "External Input",
  safeguarding: "Safeguarding",
};

const STATUS_TONE_MAP = {
  published: "active",
  active: "active",
  completed: "completed",
  draft: "warning",
  closed: "inactive",
  archived: "inactive",
  deleted: "danger",
};

export const getVersionStatusTone = (statusRaw) => {
  const key = normalizeBadgeTone(statusRaw || "");
  return STATUS_TONE_MAP[key] || "info";
};

export const formatVersionReason = (value, reasonOptions = []) => {
  if (!value) return "";
  const fromOptions = reasonOptions.find((opt) => opt.value === value)?.label;
  if (fromOptions) return fromOptions;
  return VERSION_REASON_LABELS[value] || value.replace(/_/g, " ");
};

export const formatVersionDate = (value) => {
  if (!value) return "";
  const normalized =
    typeof value === "string" ? value.replace(" ", "T") : value;
  const parsed = moment(normalized);
  return parsed.isValid() ? parsed.format("D MMM YYYY, HH:mm") : String(value);
};

/**
 * Normalize API version_list item for CcVersionCard.
 */
export const getVersionCardDisplay = (version, reasonOptions = []) => {
  const statusRaw = version?.status || "";
  const status =
    typeof statusRaw === "string"
      ? statusRaw.charAt(0).toUpperCase() + statusRaw.slice(1).toLowerCase()
      : "";

  const footer = [];
  if (version?.created_at) {
    footer.push({
      label: "Created",
      value: formatVersionDate(version.created_at),
    });
  }
  if (version?.updated_at) {
    footer.push({
      label: "Updated",
      value: formatVersionDate(version.updated_at),
    });
  }

  return {
    versionNumber: version?.version,
    status,
    statusTone: getVersionStatusTone(statusRaw),
    reason: formatVersionReason(version?.version_reason, reasonOptions),
    note: version?.version_note || "",
    footer,
    sectionsChanged: Array.isArray(version?.sectionsChanged)
      ? version.sectionsChanged
      : [],
  };
};
